<div *ngIf="scheduleData" style="min-height: 100%;">
  <div>
    <div class="pt-3 container">
      <div class="mb-2">
        <h4 id="schedule-investor-investor-name-text">{{scheduleData.name}}</h4>
        <p id="schedule-investor-company-name-text" class="text-muted mb-0">{{scheduleData.companyName}}</p>
      </div>
      <div class="d-flex justify-content-between align-items-end mb-3">
          <div id="time-timezone-text" class="text-danger mt-1" *ngIf="scheduleData.eventType === eventTypeEnum.THAILANDFOCUS">
            Timezone : {{now | date:'zzz': timezone}} (Bangkok time). The event will be conducted in physical event
          </div>
        <button type="button" class="btn btn-primary no-print" (click)="convertToPDF()"><i class="fas fa-download mr-2"></i>Download as PDF</button>
      </div>

      <div class="schedule-table-scroll">
        <ng-container *ngFor="let slot of scheduleData.slots; let slotIndex = index;">
          <div class="schedule-table-wrapper" *ngIf="slot.slotPeriods && slot.slotPeriods.length > 0">
            <table class="table meeting-schedule-table">
              <colgroup>
                <col class="col-time">
                <col class="col-room">
                <col class="col-company">
                <col class="col-presentation-file">
                <col class="col-speaker">
                <col class="col-investor">
                <col class="col-meeting-type">
              </colgroup>
              <thead>
                <tr class="slot-date-row">
                  <th colspan="7">
                    <strong id="schedule-investor-field-slot-date-text-{{slotIndex}}">
                      {{slot.slotDate | date:'mediumDate': timezone}}
                    </strong>
                  </th>
                </tr>
                <tr class="header-row">
                  <th>Date/Time</th>
                  <th id="schedule-investor-field-roome-column-text">Room</th>
                  <th id="schedule-investor-field-company-column-text">Company</th>
                  <th id="schedule-investor-field-presentation-column-text">Presentation File</th>
                  <th id="schedule-investor-field-presenter-column-text">Speaker</th>
                  <th id="schedule-investor-field-attendee-column-text">Investor</th>
                  <th id="schedule-investor-field-meeting-type-column-text" class="text-center">Meeting Type</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let slotPeriod of slot.slotPeriods; let slotPeriodIndex = index;">
                  <td>
                    <span id="schedule-investor-field-period-text-{{slotIndex}}-{{slotPeriodIndex}}">
                      {{slotPeriod.startTime | date:'HH:mm': timezone}} - {{slotPeriod.endTime | date:'HH:mm': timezone}}
                    </span>  
                    <div *ngIf="scheduleData.isSubEvent" class="sub-event-label">Corporate Briefing</div>
                  </td>
                  <td>
                    <div id="schedule-investor-field-room-link-text-{{slotIndex}}-{{slotPeriodIndex}}">{{slotPeriod.room || '-'}}</div>
                    <a *ngIf="slotPeriod.roomLink" [tooltip]="slotPeriod.roomDesc" id="schedule-investor-field-meeting-room-link-text-{{slotIndex}}-{{slotPeriodIndex}}"
                      target="_blank" [href]="slotPeriod.roomLink" class="link-blue">Meeting Link <img
                        src="assets/images/video.svg" alt=""></a>
                  </td>
                  <td>
                    <span id="schedule-investor-field-company-text-{{slotIndex}}-{{slotPeriodIndex}}">{{slotPeriod.presenter || '-'}}</span>
                    <a *ngIf="slotPeriod.listedJumpplusId" href="https://www.set.or.th/en/market/product/stock/quote/{{slotPeriod.presenterSymbol}}/company-profile/jump-plus" target="_blank" rel="noopener noreferrer">
                      <img src="assets/images/jumpplus.png" class="jumpplus-icon ml-1" alt="JumpPlus">
                    </a>
                    <span *ngIf="slotPeriod.exchangeName" class="text-muted ml-1">({{ slotPeriod.exchangeName }})</span>
                  </td>
                  <td class="presentation-file-cell">
                    <a *ngIf="slotPeriod.presentationLink" id="schedule-investor-field-presentation-link-{{slotIndex}}-{{slotPeriodIndex}}" target="_blank"
                      class="presentation-file-link" href="{{slotPeriod.presentationLink}}">
                      <i class="fas fa-download"></i>
                    </a>
                  </td>
                  <td>
                    <div *ngFor="let participant of slotPeriod.participants; let participantIndex = index;" class="speaker-row">
                      <div class="speaker-name" id="schedule-investor-field-participant-name-text-{{slotIndex}}-{{slotPeriodIndex}}-{{participantIndex}}">
                        {{participant.name || '-'}}
                      </div>
                      <div class="speaker-job" *ngIf="participant.jobTitle" id="schedule-investor-field-participant-text-job-{{slotIndex}}-{{slotPeriodIndex}}-{{participantIndex}}">
                        {{participant.jobTitle}}
                      </div>
                    </div>
                  </td>
                  <td>
                    <ng-container *ngIf="getSortedAttendees(slotPeriod).length > 0; else noAttendee">
                      <ng-container *ngFor="let attendee of getSortedAttendees(slotPeriod); let i = index;">
                        <div class="attendee-row" *ngIf="i < 3 || isAttendeesExpanded(slotIndex + '-' + slotPeriodIndex)">
                          <div class="attendee-name" [class.speaker-name-login]="isLoginPerson(attendee.name)"
                            id="schedule-investor-field-attendee-text-{{slotIndex}}-{{slotPeriodIndex}}-{{i}}">
                            {{attendee.name || '-'}}
                          </div>
                        </div>
                      </ng-container>
                      <a class="show-more-link no-print" *ngIf="getSortedAttendees(slotPeriod).length > 3 && !isAttendeesExpanded(slotIndex + '-' + slotPeriodIndex)"
                        id="schedule-investor-field-attendee-show-more-text-{{slotIndex}}-{{slotPeriodIndex}}"
                        (click)="toggleAttendees(slotIndex + '-' + slotPeriodIndex)">show more</a>
                      <a class="show-more-link no-print" *ngIf="getSortedAttendees(slotPeriod).length > 3 && isAttendeesExpanded(slotIndex + '-' + slotPeriodIndex)"
                        id="schedule-investor-field-attendee-show-less-text-{{slotIndex}}-{{slotPeriodIndex}}"
                        (click)="toggleAttendees(slotIndex + '-' + slotPeriodIndex)">show less</a>
                    </ng-container>
                    <ng-template #noAttendee></ng-template>
                  </td>
                  <td id="schedule-investor-field-meeting-type-text-{{slotIndex}}-{{slotPeriodIndex}}" class="text-center">
                    <span [ngClass]="{'badge--meeting-type': slotPeriod.meetingType === 'VIRTUALGROUP'}">{{slotPeriod.meetingType | meetingType}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="mx-5 px-5 pt-4" *ngIf="isErr">
    <h6 id="schedule-investor-line1-error-text">ERROR</h6>
    <h3 id="schedule-investor-line2-error-text">PAGE NOT FOUND</h3>
    <p id="schedule-investor-line3-error-text">The page you requested was not found.</p>
  </div>
</div>
